import { AutopilotWorkflowModel } from './types';

export const isToolSelected = (
  workflow: AutopilotWorkflowModel,
  toolId: string,
): boolean => {
  return workflow.tool_definitions.some(tool => tool.tool_id === toolId);
};
